module.exports = __webpack_public_path__ + "assets/86daaac205787bc641669b51f0a608ab.mp3";